import { dbPost, dbForm, dbGet } from '../../../apis/commonApi';
import html2pdf from 'html2pdf.js';

class ExpertAnalyzeDetailController {
  constructor(
    store,
    modalService,
    validateService,
    { svcObj, setSvcObj },
    { detailList, setDetailList },
    { render, setRender },
    detailListRef,
    printRef,
    navigate,
    setLoading
  ) {
    this.store = store;
    this.modalService = modalService;
    this.validateService = validateService;
    this.svcObj = svcObj;
    this.setSvcObj = setSvcObj;
    this.detailList = detailList;
    this.setDetailList = setDetailList;
    this.render = render;
    this.setRender = setRender;
    this.detailListRef = detailListRef;
    this.printRef = printRef;
    this.navigate = navigate;
    this.setLoading = setLoading;
  }

  // 조회
  async fnGetExpertAnalyzeDetail() {
    let response = null;

    try {
      response = await dbPost('/expert-analyze/detail/list.do', this.svcObj);

      if (response instanceof Error) {
        this.modalService.errorAlert('데이터 처리중 에러가 발생하였습니다');
      } else {
        this.setDetailList(response);
        if (response.length > 0) {
          this.setSvcObj({ ...this.svcObj, status: response[0].status });
        }
      }
    } catch (error) {
      this.modalService.errorAlert('데이터 처리중 에러가 발생하였습니다');
    }
  }

  // 전문가 매칭
  async fnExpertMatch() {
    let response = null;

    try {
      response = await dbPost('/expert-analyze/match.do', {
        exprtAnlsId: this.svcObj.exprtAnlsId,
      });

      if (response instanceof Error) {
        this.modalService.errorAlert('데이터 처리중 에러가 발생하였습니다');
      } else if (response === 1) {
        this.modalService.successAlert('전문가가 매칭 되었습니다.');
        this.setSvcObj({ ...this.svcObj, status: 'EXPRT03' });
      } else {
        this.modalService.noticeAlert(
          '이미 다른 전문가가 매칭된 항목입니다.',
          () => {
            this.navigate('/expert/analyze/list');
          }
        );
      }
    } catch (error) {
      this.modalService.errorAlert('데이터 처리중 에러가 발생하였습니다');
    }
  }

  // 분석 완료, 임시저장
  async fnSave(isTemp) {
    if (isTemp === 'Y' || this.fnValidate()) {
      // // 분석 완료
      // if (isTemp === 'N') {
      //   // PDF 서버저장
      //   this.fnHandleSavePdf();
      // }
      // // 임시저장
      // else {
      this.fnSaveProcess(null, isTemp);
      // }
    }
  }

  fnValidate() {
    let errorMsg = '';

    for (let i = 0; i < this.detailListRef.current.length; i++) {
      const detail = this.detailListRef.current[i];
      if (
        detail.anlsEnvYn === 'N' &&
        detail.anlsPhyYn === 'N' &&
        detail.anlsPrYn === 'N'
      ) {
        errorMsg += `<b style='line-height: 2.5;'>${detail.workNm}</b><br />`;
        errorMsg += '근본원인을 선택해 주세요<br />';
      }

      if (!detail.anlsCn) {
        errorMsg += '현황 및 문제점을 입력해주세요<br />';
      }
    }

    if (errorMsg.length === 0) {
      return true;
    } else {
      this.modalService.noticeAlert(errorMsg);
      return false;
    }
  }

  async fnSaveProcess(fileData, isTemp) {
    let response = null;
    try {
      response = await dbPost('/expert-analyze/detail/save.do', {
        isTemp: isTemp,
        exprtAnlsId: this.svcObj.exprtAnlsId,
        detailList: this.detailListRef.current,
        fileId: null,
        userNm: this.svcObj.userNm,
        anlsDmndDt: this.svcObj.anlsDmndDt,
        taskNm: this.svcObj.taskNm,
      });

      if (response instanceof Error) {
        this.modalService.errorAlert('데이터 처리중 에러가 발생하였습니다');
      } else if (isTemp === 'Y') {
        this.modalService.successAlert('임시저장 되었습니다.');
      } else {
        this.modalService.successAlert('분석완료 되었습니다.');
        // let splitedData = fileData.filePath.split('/');
        this.setSvcObj({
          ...this.svcObj,
          status: 'EXPRT05',
          // orgnflNm: '전문가 분석보고서.pdf',
          // chgFileNm: splitedData[splitedData.length - 1],
        });
      }
    } catch (error) {
      this.modalService.errorAlert('데이터 처리중 에러가 발생하였습니다');
    }
  }

  // PDF 서버저장
  fnHandleSavePdf() {
    this.printRef.current.style.display = 'block';
    this.setRender(this.render + 1);

    this.setLoading(true);

    const element = this.printRef.current;
    if (!element) {
      this.setLoading(false);
      return;
    }
    const options = {
      filename: '전문가 분석보고서.pdf',
      margin: 0,
      image: { type: 'jpeg', quality: 1 },
      html2canvas: { scale: 1.5 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
      pagebreak: {
        mode: ['css'],
      },
    };

    // PDF 다운로드
    // html2pdf()
    //   .set(options)
    //   .from(element)
    //   .save()
    //   .then(() => {
    //     this.printRef.current.style.display = 'none';
    //   });
    // this.setLoading(false);

    // PDF 서버저장
    const pdfFile = html2pdf().set(options).from(element).toPdf();
    pdfFile.output('datauristring').then(
      function (pdf) {
        const file = this.dataURLtoFile(pdf, '전문가 분석보고서.pdf');

        this.fnFileUpload(file).then(
          async function (data) {
            this.printRef.current.style.display = 'none';
            this.fnSaveProcess(data, 'N');
          }.bind(this)
        );
      }.bind(this)
    );

    // .catch(e => {
    //   this.setLoading(false);
    //   this.modalService.errorAlert('보고서 작성중 에러가 발생하였습니다');
    // });
  }

  // base64 -> File
  dataURLtoFile(dataurl, fileName) {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], fileName, { type: mime });
  }

  // PDF 서버 업로드
  async fnFileUpload(file) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('entSn', this.store?.entSn);
    formData.append('userSn', this.store?.userSn);
    formData.append('userType', this.store?.userType);

    const uploadUrl = '/common/file/upload.do';
    const response = await dbForm(uploadUrl, formData);

    return response;
  }

  // PDF 다운로드
  async fnDownloadExpertPDF() {
    const url =
      process.env.REACT_APP_BACKEND_URL + 'files/' + this.svcObj.chgFileNm;
    const res = await fetch(url);
    const arrayBuffer = await res.arrayBuffer();
    const blob = new Blob([arrayBuffer], { type: 'application/octet-stream' });
    const blobURL = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = blobURL;
    a.style.display = 'none';
    a.rel = 'noopener noreferrer';
    a.download = this.svcObj.orgnflNm;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
}

export default ExpertAnalyzeDetailController;
